import { isoStringToUTCDate } from '../../../../utils/dates';

import { COMING_SOON } from './availabilityTypes';

/**
 * Returns an ISOString date of the next available "coming soon" ticket.
 */
export default (races = []) => {
  const availabilePrices = []
    .concat(
      ...races
        .filter(r => !!r.tickets)
        .map(r =>
          r.tickets.tickets
            .filter(t => t.availability.type === COMING_SOON)
            .map(t => t.availability.from),
        ),
    )
    .sort((a, b) => isoStringToUTCDate(a) - isoStringToUTCDate(b));
  return availabilePrices[0] || null;
};



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/helpers/getNextAvailableTicketDate.js